import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.slice";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { useCallback } from 'react';
var store = {
  history: [],
  add: function add(item) {
    this.history = [item].concat(_toConsumableArray(this.history.filter(function (x) {
      return x.location !== item.location;
    }))).slice(0, 10);
  }
};
export default function usePageHistory() {
  var add = useCallback(function (item) {
    return store.add(item);
  }, []);
  var history = useCallback(function () {
    return store.history;
  }, []);
  return [add, history];
}